import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AnnouncementService } from '../backoffice/announcements/announcement.service';
import { MovementService } from '../backoffice/movements/movement.service';
import { AuthenticationService } from '../../auth/authentication.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  announcements = [];
  movements = [];
  customer = false;

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = 'Estado';
  showYAxisLabel = false;
  yAxisLabel = 'Contentores';

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  colorScheme2 = {
    domain: ['#2D728F', '#3B8EA5', '#F5EE9E', '#F49E4C']
  };

  constructor(private router: Router, private announcementservice: AnnouncementService,
    private movementservice: MovementService, private auth: AuthenticationService) {

  }

  ngOnInit() {

    if (window.innerWidth < 501) {
      this.router.navigateByUrl('mobile/movements');
    }

    if (this.auth.hasRole('CUSTOMER_ROLE')) {
      this.customer = true;
    }

    this.announcementservice.countOpen()
      .subscribe(return_value => {
        return_value.forEach(element => {
          this.announcements.push({ name: element.Designation, value: element.Count });

          this.announcements = [...this.announcements];

        });
      },
      error => { });

    this.movementservice.countOpen()
      .subscribe(return_value => {
        return_value.forEach(element => {
          this.movements.push({ name: element.Designation, value: element.Count });

          this.movements = [...this.movements];

        });
      },
      error => { });

  }

  public onSelectAnnouncements(event) {
    this.router.navigateByUrl('backoffice/announcements');
  }

  public onSelectMovements(event) {
    this.router.navigateByUrl('backoffice/movements');
  }

  public onOpenSummary(event) {
    this.router.navigateByUrl('customer/dayMovementsResume');
  }

  public onOpenTruckload(event) {
    this.router.navigateByUrl('customer/loadtruck');
  }


}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/dashboard/dashboard.component.ts